"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateAgentDto = instanceOfUpdateAgentDto;
exports.UpdateAgentDtoFromJSON = UpdateAgentDtoFromJSON;
exports.UpdateAgentDtoFromJSONTyped = UpdateAgentDtoFromJSONTyped;
exports.UpdateAgentDtoToJSON = UpdateAgentDtoToJSON;
exports.UpdateAgentDtoToJSONTyped = UpdateAgentDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateAgentDto interface.
 */
function instanceOfUpdateAgentDto(value) {
    if (!('agentId' in value) || value['agentId'] === undefined)
        return false;
    return true;
}
function UpdateAgentDtoFromJSON(json) {
    return UpdateAgentDtoFromJSONTyped(json, false);
}
function UpdateAgentDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'agentId': json['agentId'],
    };
}
function UpdateAgentDtoToJSON(json) {
    return UpdateAgentDtoToJSONTyped(json, false);
}
function UpdateAgentDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'agentId': value['agentId'],
    };
}
